import { createAction } from "@reduxjs/toolkit";
import {
  getPostDetailsActionTypes,
  setCommentsCountActionTypes,
  setSibilingsActionType,
} from "./actionTypes";

export const getPostDetails = createAction(
  getPostDetailsActionTypes.request,
  (payload) => ({ payload }),
);

export const getPostDetailsSuccess = createAction(
  getPostDetailsActionTypes.success,
  (payload) => ({ payload }),
);

export const getPostDetailsFailure = createAction(
  getPostDetailsActionTypes.failure,
  (payload) => ({ payload }),
);

export const getPostDetailsReset = createAction(
  getPostDetailsActionTypes.reset,
);

export const setCommentsCount = createAction(setCommentsCountActionTypes);

export const setSibilings = createAction(setSibilingsActionType);
